import * as Yup from 'yup'
import { schema } from '../../../utils/schemaValidation'
import { getInitialState } from '../../../utils/formikUpdate'
import { COUNTRY_PHONE_CODES, DEFAULT_COUNTRY_PHONE_CODE } from '../../../config/countryPhoneCodes'

export const ROLE_FIELD_NAME = 'roleId'

const PHONE_CODE_OPTIONS = Object.fromEntries(
  COUNTRY_PHONE_CODES.map(({ icon, label, value }) => [value, `${icon} ${label} (${value})`]),
)

export const datasetFormik = roleOptions => {
  const ITEMS_USER_FORMIK = [
    { x: 12, name: 'username', initvalue: '', label: 'Nombre' },
    { x: 12, name: 'lastname', initvalue: '', label: 'Apellido' },
    { x: 12, name: 'email', initvalue: '', label: 'Correo electrónico' },
    {
      x: 5,
      name: 'phone_code',
      initvalue: DEFAULT_COUNTRY_PHONE_CODE,
      label: 'Código',
      options: PHONE_CODE_OPTIONS,
    },
    {
      x: 7,
      name: 'phone_number',
      initvalue: '',
      label: 'Celular (opcional)',
      placeholder: '987654321',
    },
    {
      x: 12,
      name: ROLE_FIELD_NAME,
      initvalue: '',
      label: 'Rol',
      options: roleOptions,
    },
  ]

  const INITIAL_FORMIK_STATE = getInitialState(ITEMS_USER_FORMIK)

  const FORM_VALIDATION = Yup.object().shape({
    ...schema.USERNAME,
    ...schema.LASTNAME,
    ...schema.EMAIL,
    ...schema.PHONE_CODE,
    ...schema.PHONE_OPTIONAL,
    [ROLE_FIELD_NAME]: Yup.string().required('Obligatorio'),
  })

  return {
    INITIAL_FORMIK_STATE,
    ITEMS_USER_FORMIK,
    FORM_VALIDATION,
  }
}
